// Card de produto da grade do totem (antigo TotemProductCard, verbatim).
import { useState } from "react";
import { Coins, ImageOff } from "lucide-react";
import { fmt, getImageUrl, isPngImage } from "../lib/helpers";
import { precoPromocional } from "../lib/promocao";
import { VideoDoCartao } from "../../produto-midias";

export default function CardProduto({ product, onClick, promo, cashbackPct = null, midias = null }) {

  const [imgErr, setImgErr] = useState(false);
  const isCombo = product.product_type === "combo";
  const comboPrice = product.sale_price || 0;
  const simplePrice = product.simple_price || 0;
  const price = comboPrice;
  const promoSimple = precoPromocional(simplePrice, promo);
  const promoCombo = precoPromocional(comboPrice, promo);
  const promoPrice = precoPromocional(price, promo);

  return (
    <button onClick={onClick} className="bg-zinc-800 rounded-2xl overflow-hidden border border-zinc-700 hover:border-orange-500/50 transition-all text-left flex flex-col active:scale-[0.98]">
      <div className={`w-full aspect-square relative ${isPngImage(product.photo_url) ? "bg-zinc-700" : "bg-zinc-800"}`}>
        {product.photo_url && !imgErr ? (
          <img src={getImageUrl(product.photo_url)} alt={product.name} className={`w-full h-full ${isPngImage(product.photo_url) ? "object-contain p-2" : "object-cover"}`} onError={() => setImgErr(true)} />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-zinc-700"><ImageOff className="w-10 h-10 text-zinc-500" /></div>
        )}
        <VideoDoCartao midias={midias} />
        {promo && <div className="absolute top-2 left-2 bg-green-500 text-white text-xs font-bold px-2 py-1 rounded-full shadow">{promo.type === "percentage" ? `-${promo.value}%` : `R$ ${fmt(promo.value)}`}</div>}
      </div>
      {cashbackPct > 0 && (
        <div className="bg-emerald-600 text-white text-[11px] font-bold px-2 py-1 flex items-center justify-center gap-1" data-e2e="selo-cashback"><Coins className="w-3 h-3" /> {String(cashbackPct).replace(".", ",")}% de cashback</div>
      )}
      <div className="p-3 flex-1 flex flex-col">
        <h3 className="text-sm font-semibold text-zinc-100 line-clamp-2 leading-tight">{product.name}</h3>
        {product.description && <p className="text-xs text-zinc-400 mt-1 line-clamp-2">{product.description}</p>}
        <div className="mt-auto pt-2">
          {isCombo && simplePrice > 0 ? (
            <div className="flex justify-around items-start gap-2 pt-1">
              <div className="flex flex-col items-center gap-0.5">
                <span className="text-base leading-none">🍽️</span>
                <span className="text-[11px] font-bold text-zinc-400 uppercase tracking-wider">Individual</span>
                {promoSimple != null && promoSimple !== simplePrice ? (
                  <><span className="text-xs line-through text-zinc-500 mt-1">R$ {fmt(simplePrice)}</span><span className="font-extrabold text-base text-green-500">R$ {fmt(promoSimple)}</span></>
                ) : (
                  <span className="font-extrabold text-base text-orange-500 mt-1">R$ {fmt(simplePrice)}</span>
                )}
              </div>
              <div className="w-px h-12 bg-zinc-600/50 self-center" />
              <div className="flex flex-col items-center gap-0.5">
                <span className="text-base leading-none">🍽️🍟🥤</span>
                <span className="text-[11px] font-bold text-zinc-400 uppercase tracking-wider">Combo</span>
                {promoCombo != null && promoCombo !== comboPrice ? (
                  <><span className="text-xs line-through text-zinc-500 mt-1">R$ {fmt(comboPrice)}</span><span className="font-extrabold text-base text-green-500">R$ {fmt(promoCombo)}</span></>
                ) : (
                  <span className="font-extrabold text-base text-orange-500 mt-1">R$ {fmt(comboPrice)}</span>
                )}
              </div>
            </div>
          ) : promoPrice != null && promoPrice !== price ? (
            <div><span className="text-xs line-through text-zinc-500">R$ {fmt(price)}</span><p className="text-lg font-black text-green-500">R$ {fmt(promoPrice)}{product.sale_unit && product.sale_unit !== "un" && <span className="text-[10px] font-normal text-zinc-400 ml-0.5">/{product.sale_unit}</span>}</p></div>
          ) : (
            <p className="text-lg font-black text-orange-500">R$ {fmt(price)}{product.sale_unit && product.sale_unit !== "un" && <span className="text-[10px] font-normal text-zinc-400 ml-0.5">/{product.sale_unit}</span>}</p>
          )}
        </div>
      </div>
    </button>
  );
}
